module.exports = __webpack_public_path__ + "static/img/15.c002597.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/sp/15.png
// module id = 5t2N
// module chunks = 0